<template>
  <component :is="conditionalElement" v-bind="conditionalProps(props.item.url)" class="CartItem__Image">
    <picture>
      <source media="(min-width:320px)" :srcset="props.item.image" />
      <img lazy="lazy" :src="props.image" :alt="props.item.image?.alt || 'Product Image'" />
    </picture>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import { useCartStore } from './Composables/Store';

const store = useCartStore();
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const conditionalElement = computed(() => {
  const ineligibleItems = store.getIneligibleItems;
  const variant = props.item.variant_id;
  const isIneligible = ineligibleItems.includes(variant);
  return isIneligible ? 'div' : 'a';
});

const conditionalProps = computed(() => {
  return (url) => {
    const isLink = conditionalElement.value === 'a';
    if (!isLink) return {};
    return {
      href: url,
    };
  };
});
</script>
